var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65 11.95L.3 16l4.396-1.156A7.715 7.715 0 101.65 11.95zm5.817-2.17a.377.377 0 01-.377-.37c-.062-.908.261-1.49 1.12-2.008.8-.492 1.043-.812 1.043-1.407V5.99c0-.614-.478-1.049-1.18-1.049-.715 0-1.182.48-1.219 1.139a.058.058 0 01-.058.05H5.228a.064.064 0 01-.064-.063c.05-1.503 1.112-2.609 3.02-2.609 1.772 0 2.953 1.01 2.953 2.474v.007c0 .959-.454 1.63-1.33 2.16-.827.493-1.057.813-1.057 1.42a.262.262 0 01-.262.262h-1.02zm1.5 2.06c0 .562-.453 1.003-1.019 1.003a1.003 1.003 0 110-2.008c.566 0 1.02.442 1.02 1.004z",
    fill: "#6A6A6A"
  })));
}

export default SvgQuestion;